import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * Aura + uygulama tema değişkenleri. Yalnızca semantic katman:
 * birincil renkler ThemeColorService / body sınıflarıyla gelen
 * --main-primary-color ve --main-hover-color ile hizalanır.
 */
export const SmarteraAuraPreset = definePreset(Aura, {
	semantic: {
		colorScheme: {
			light: {
				primary: {
					color: 'var(--main-primary-color)',
					contrastColor: '#ffffff',
					hoverColor: 'var(--main-hover-color)',
					activeColor: 'var(--main-hover-color)',
				},
				highlight: {
					background: 'color-mix(in srgb, var(--main-primary-color) 14%, white)',
					focusBackground: 'color-mix(in srgb, var(--main-primary-color) 22%, white)',
					color: 'var(--main-primary-color)',
					focusColor: 'var(--main-hover-color)',
				},
				formField: {
					focusBorderColor: 'var(--main-primary-color)',
					floatLabelFocusColor: 'var(--main-primary-color)',
				},
			},
		},
	},
	components: {
		dialog: {
			title: {
				fontWeight: '600',
				fontSize: '1.1rem',
			},
			footer: {
				padding: '10px',
			},
			root: {
				borderRadius: '2px',
				borderColor: 'none',
			},
			header: {
				padding: '0',
			},
			content: {
				padding: '0',
			},
		},
		menubar: {
			root: {
				borderRadius: '2px',
				background: 'var(--main-dark-color)',
			},
			baseItem: {
				borderRadius: '2px',
				padding: '0.75rem 0.9rem',
			},
			item: {
				padding: '0.75rem 0.9rem',
				borderRadius: '2px',
				color: '#ffffff',
				activeBackground: 'var(--main-primary-color)',
				focusBackground: 'var(--main-primary-color)',
				focusColor: '#ffffff',
				activeColor: '#ffffff',
				icon: {
					color: 'var(--main-primary-color)',
					focusColor: '#ffffff',
					activeColor: '#ffffff',
				},
			},
			submenu: {
				padding: '2',
				gap: '0',
				background: 'var(--main-dark-color)',
				borderRadius: '2px',
				borderColor: 'var(--main-dark-color)',
				icon: {
					color: '#fff',
					focusColor: '#ffffff',
					activeColor: '#ffffff',
					size: '1.25rem',
				},
			},
		},
		card: {
			root: {
				borderRadius: '2px',
			},
		},
		tabs: {
			tablist: {
				background: 'none',
				borderWidth: '0',
			},
			tabpanel: {
				background: 'none',
			},
		},
		accordion: {
			header: {
				padding: '1rem',
				background: 'var(--main-dark-color)',
				color: '#ffffff',
				hoverBackground: 'var(--main-primary-color)',
				hoverColor: '#ffffff',
				activeBackground: 'var(--main-primary-color)',
				activeColor: '#ffffff',
				activeHoverBackground: 'var(--main-light-color)',
				activeHoverColor: '#ffffff',
				borderColor: 'var(--main-dark-color)',
				fontWeight: '600',
				toggleIcon: {
					color: '#ffffff',
					hoverColor: '#ffffff',
					activeColor: '#ffffff',
					activeHoverColor: '#ffffff',
				},
			},
			content: {
				borderWidth: '1px',
				borderColor: '#e1e2ec',
			},
		},
	},
});
